import { z } from "zod";

import { DEVOLUTIVA_MESSAGES } from "@/constants/messages";

export const FormSchema = z.object({
  cpf: z
    .string()
    .nonempty("O CPF é obrigatório")
    .regex(/^\d{11}$/, "CPF deve conter exatamente 11 dígitos numéricos"),
  nome: z.string().nonempty("O Nome é obrigatório"),
  matricula: z
    .string()
    .nonempty("A Matrícula é obrigatória")
    .regex(/^\d+$/, "A Matrícula deve conter apenas números"),
  cargo: z.string().nonempty("O Cargo é obrigatório"),
});

export type FormData = z.infer<typeof FormSchema>;

export const DevolutivaSchema = z.object({
  comment: z.string().trim().min(1, DEVOLUTIVA_MESSAGES.COMMENT_REQUIRED),
});

export type DevolutivaFormData = z.infer<typeof DevolutivaSchema>;
